





































































import { VDatePicker, VMenu, VTextField, VBtn, VSpacer } from 'vuetify/lib'
import { format, parseISO } from 'date-fns'
import { mdiCalendar } from '@mdi/js'
import { defineComponent, computed, ref } from '@vue/composition-api'

export default defineComponent({
  inheritAttrs: false,
  name: 'base-input-date-picker',
  components: {
    VDatePicker,
    VMenu,
    VTextField,
    VBtn,
    VSpacer
  },
  props: {
    dateValue: String,
    allowedDates: Function,
    label: String,
    rules: Array,
    required: {
      type: Boolean,
      default: false
    }
  },
  setup (props) {
    const date = ref(props.dateValue)
    const pickerMenu = ref<any>(null)
    const menuState = ref<boolean>(false)
    const picker = ref<any>(null)
    const activator = ref<any>(null)

    // COMPUTED
    const computedDateFormatted = computed(() => {
      return date.value ? format(parseISO(date.value), 'MMMM d, yyyy') : ''
    })

    const focusOnPicker = () => {
      menuState.value = true
      // We focus on the picker because it is being added at the end of the page hierarchy and can only be navigated via tab.
      // Without the focus you would have to tab through the rest of the page to get to the picker.
      setTimeout(() => picker.value.focus(), 100)
    }

    const saveSelection = () => {
      pickerMenu.value.save(date.value)
      setTimeout(() => activator.value.focus(), 100)
    }

    const closePicker = () => {
      menuState.value = false
      setTimeout(() => activator.value.focus(), 100)
    }

    return {
      date,
      pickerMenu,
      menuState,
      mdiCalendar,
      computedDateFormatted,
      focusOnPicker,
      saveSelection,
      closePicker,
      picker,
      activator
    }
  }
})
